import { useEffect, useState } from "react";
import "./ChatBotComponent.css";
import { useSelector } from "react-redux";
import _ from "lodash";
// import jwt from 'jsonwebtoken'

const buttonStyle = {
  zIndex: 42424242,
  right: "20px",
  bottom: "20px",
  backgroundColor: "white",
  borderColor: "white",
};

const buttonStyle1 = {
  zIndex: 42424242,
  right: "20px",
  // bottom: '20px',
  backgroundColor: "white",
  borderColor: "white",
  bottom: "525px",
};

const ChatBotComponent = () => {
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [clicked, setClicked] = useState(false);
  const [fullScreenEnabled, setFullScreenEnabled] = useState(true);
  const [showChatBot, setShowChatBot] = useState(false);
  const [botToken, setBotToken] = useState("");
  const org = "XSEL";

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload) &&
        !_.isEmpty(authBroker.payload?.user)
      ) {
        console.log(authBroker.payload);
        // const payload = {
        //     userId: authBroker.payload.user.email,
        //     org: 'XSEL',
        //     url: CONFIG.DOMAIN_URL,
        //     exp: moment().add(4, 'hours').unix()
        // }
        if (authBroker.payload.user.bot_token) {
          setBotToken(authBroker.payload.user.bot_token);
          setShowChatBot(true);
        }
      }
    }
  }, [authBroker]);

  const FullScreenHandler = (status) => {
    setFullScreenEnabled(status);
    console.log("status---", status);
    if (status) {
      const div = document.getElementsByClassName("chat-bot-abs")[0];
      div.classList.add("chat-bot-mx");
    } else {
      console.log("removed");
      const div1 = document.getElementsByClassName("chat-bot-abs")[0];
      div1.classList.remove("chat-bot-mx");
    }
  };

  //   useEffect(() => {
  //     console.log("chatbot clicked");
  //     const div = document.getElementsByClassName("chat-bot-abs")[0];
  //     if (clicked && div.classList.contains("chat-bot-mx")) {
  //       div.classList.add("chat-bot-mx");
  //     }
  //   }, [clicked]);

  const [isMinimized, setisMinimized] = useState(false);

  const handleMinimize = () => {};

  const [loader, setLoader] = useState(true);

  const closingAI = () => {
    setClicked(!clicked);
  };

  const loaderStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    marginTop: "6%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  };

  const [iframeLoaded, setIframeLoaded] = useState(false);

  const openAI = () => {
    setClicked(!clicked);
    if (!iframeLoaded) {
      setIframeLoaded(true);
    }
  };

  return (
    <>
      {showChatBot ? (
        <>
          {!clicked ? (
            <button
              part="button"
              className="position-fixed shadow-md rounded-full hover:scale-110 
                    active:scale-95 transition-transform duration-200 d-flex justify-content-center align-items-center animate-fade-in w-18 h-18"
              style={clicked ? buttonStyle1 : buttonStyle}
              onClick={() => openAI()}
            >
              <img
                alt="Bubble button icon"
                src="/images/dummy-dappy-image.png"
                className={`user-img-rounded rounded-full ${
                  clicked
                    ? "object-coverscale-0 opacity-0"
                    : "object-coverscale-100 opacity-100"
                } w-18`}
              />
              <svg
                viewBox="0 0 24 24"
                className={`position-absolute duration-200 transition scale-0 -rotate-180 ${
                  clicked ? "opacity-100" : "opacity-0"
                } w-9`}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
                ></path>
              </svg>
            </button>
          ) : (
            ""
          )}

          {iframeLoaded && (
            <div
              className={`${
                clicked ? "d-block" : "d-none"
              } position-absolute chat-bot-abs chat-bot-mx`}
            >
              <div className="chat-bot-header">
                <h2 class="headingrows">Xsel Coach</h2>
                <ul>
                  <li onClick={() => FullScreenHandler(!fullScreenEnabled)}>
                    <i class="fa fa-window-maximize" aria-hidden="true"></i>
                  </li>
                  <li>
                    <button
                      part="button"
                      class="position-fixed small-arrow-fixed shadow-md rounded-full hover:scale-110  active:scale-95 transition-transform duration-200 d-flex justify-content-center align-items-center animate-fade-in w-18 h-18"
                      style={{
                        zIndex: 42424242,
                        right: "20px",
                        bottom: "20px",
                        backgroundColor: "white",
                        borderColor: "white",
                      }}
                      onClick={() => closingAI()}
                    >
                      <img
                        alt="Bubble button icon"
                        src="../images/dummy-dappy-image.png"
                        class="user-img-rounded rounded-full object-coverscale-0 opacity-0 w-18"
                      />
                      <svg
                        viewBox="0 0 24 24"
                        class="drop-icon position-absolute duration-200 transition scale-0 -rotate-180 opacity-100 w-9"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
                        ></path>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
              {loader && (
                <div style={loaderStyle}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              <iframe
                type="text/html"
                id="chat-player"
                title="chat-bot"
                onLoad={() => setLoader(false)}
                // src={`https://dev.infiniit.ai/research-center/?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJuaXRpbi4xLmdhcmciLCJ1cmwiOiJodHRwczovL3hzZWwuaW5maW5paXQuYWkvIiwib3JnIjoiWFNFTCIsImlhdCI6MTcwMjM4MjI2MywiZXhwIjoxNzAyNDkwMjYzfQ.li01v3QCYIq0eBbAJxflpzs73zZ0Lq0KT5BR92Erb-Y`}></iframe>
                src={
                  window.location.origin.includes("local") ||
                  window.location.origin.includes("192.168") ||
                  window.location.origin.includes("dev") ||
                  window.location.origin.includes("stg")
                    ? `https://dev.infiniit.ai/research-center/?aitoken=${botToken}&org=${org}`
                    : `https://www.infiniit.ai/research-center/?aitoken=${botToken}&org=${org}`
                }
              ></iframe>
            </div>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default ChatBotComponent;
